<template>
  <div>
    <v-app class="bg-transparent ca-page">
      <v-main>
        <v-tabs v-model="active_tab" background-color="white" color="deep-purple accent-4" left>
          <v-tab @click="tabIndex = 0">Account</v-tab>
          <v-tab @click="tabIndex = 1" v-if="!this.isRoark" >Users</v-tab>
          <v-tab @click="tabIndex = 2" v-if="!this.isRoark">Integrations</v-tab>
          <v-tab @click="tabIndex = 3" v-if="this.is_subscribed && !this.isRoark">Email</v-tab>
          <v-tab @click="tabIndex = 4" v-if="this.isRoark">API Settings</v-tab>
        </v-tabs>

        <v-tabs-items v-model="active_tab">
          <v-tab-item :key="0">
            <v-container fluid>
              <account-settings></account-settings>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="1" v-if="!this.isRoark">
            <v-container fluid>
              <users></users>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="2" v-if="!this.isRoark">
            <v-container fluid>
              <integrations></integrations>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="3" v-if="this.is_subscribed && !this.isRoark">
            <v-container fluid>
              <email-roi-rules></email-roi-rules>
              <email-sender></email-sender>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="4" v-if="this.isRoark">
            <api-setting>
            </api-setting>
          </v-tab-item>
        </v-tabs-items>
      </v-main>
    </v-app>
  </div>
</template>

<style scoped>
  .tabs /deep/ .tab-pane:focus {
    outline: none;
  }
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AccountSettings from "@/view/components/accounts/AccountSettings.vue";
import EmailSender from "@/view/components/accounts/EmailSender.vue";
import EmailRoiRules from "@/view/components/accounts/EmailRoiRules.vue";
import Users from "@/view/components/accounts/Users.vue";
import Integrations from "@/view/components/accounts/Integrations.vue";
import ApiSetting from "@/view/components/accounts/ApiSettings.vue";

export default {
  name: "account",
  components: {
    AccountSettings,
    EmailSender,
    Users,
    EmailRoiRules,
    Integrations,
    ApiSetting
  },
  data() {
    return {
      active_tab: 0,
      is_subscribed: false,
      isRoark: false
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    accountSetting(){
      return this.$store.getters["getAccountSettings"]
    }
  },
  watch: {
    accountSetting(newVal){
      let accountSettings = newVal
      let companyName = accountSettings.company_name
      this.is_subscribed =  accountSettings.company_details.company.is_subscribed

      if ( companyName == 'Roark' || companyName.toLowerCase() == 'roark'){
        this.isRoark = true
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'Aben';
      }
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Account" }]);
    this.$store.commit("setLocationVisibile", false);
    let flowId = window.localStorage.getItem("flowReturn");
    this.active_tab = flowId ? 1 : 0;
  }
};
</script>
